// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_1sajk","inner":"inner_1XMuA","item":"item_1C7V9","text":"text_3dTyD","button":"button_1wMSj","buttonLeft":"buttonLeft_19QqX","icon":"icon_2CyrG"};